module.exports = __webpack_public_path__ + "static/media/me.9f44f9c1.png";